// Works.jsx
import { useLocation } from "react-router-dom";
import { useEffect, useRef } from "react";
import { Box, HStack, Text } from "@chakra-ui/react";
import React, { useState } from "react";
import DesignCards1 from "component/home/component/DiscoverDesign/DesignCards1";


const tabs = ["All", "Branding", "Marketing", "Website", "Application"]; 

function Works() {
  const location = useLocation();
  const [selectedTab, setSelectedTab] = useState(0);
  const filterRef = useRef(null);

  useEffect(() => {
    if (location.state?.selectedTabLabel) {
      const tabIndex = tabs.indexOf(location.state.selectedTabLabel);
      if (tabIndex !== -1) {
        setSelectedTab(tabIndex);
        setTimeout(() => {
          filterRef.current?.scrollIntoView({ behavior: "smooth" });
        }, 100);
      }
    }
  }, [location]);

  return (
    <Box pt={4} pb={20} bg="#F7EAD9">
      {/* Tab Navigation */}
      <HStack ref={filterRef} justify="center" flexWrap="wrap">
        {tabs.map((tab, index) => (
          <React.Fragment key={tab}>
            <Text
              textAlign="center"
              fontSize={{ base: "lg", sm: "3xl", md: "4xl" }}
              color={index === selectedTab ? "#000" : "#8E8E8E"}
              cursor="pointer"
              onClick={() => setSelectedTab(index)}
            >
              {tab}
            </Text>
            {index !== tabs.length - 1 && (
              <Text textAlign="center" fontSize="2xl" color="#8E8E8E">
                -
              </Text>
            )}
          </React.Fragment>
        ))}
      </HStack>

      {/* Card Grid */}
      <Box mt={10} px={10} bg="#F7EAD9">
        <DesignCards1 selectedTab={selectedTab} />
      </Box>
    </Box>
  );
}

export default Works;
